<template>
  <div class="card-tooltip position-relative d-flex justify-content-center align-items-center" @mouseover="handleTooltipHover" @mouseout="handleTooltipHover">
    <div class="card-tooltip-title position-absolute bg-primary align-items-center" :class="{ 'd-flex': show, 'd-none': !show }" >
      <div class="position-relative d-flex align-items-center">
        <small class="d-inline-block lh-14 text-white text-center w-100 fw-bold">{{ title }}</small>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data(){
    return {
      show: false
    }
  },
  methods: {
    handleTooltipHover() {
      this.show = !this.show
    }
  }
}
</script>
